import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { SiteConfigContext } from '@bingads-webui-campaign-react/smart-page-context';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { getComponentById } from '@bingads-webui-campaign-react/smart-component-util';

import { proxyReadIntroductionComponentConfig } from './component-config-reader';
import { SmartIntroductionView } from './smart-introduction-view';

export const SmartIntroductionConnector = ({ id }) => {
  const { siteConfig } = useContext(SiteConfigContext);
  const i18n = useContext(I18nContext);
  const componentConfig = getComponentById(siteConfig, id);
  const {
    headline,
    defaultHeadline,
    description,
    defaultDescription,
  } = proxyReadIntroductionComponentConfig(componentConfig, siteConfig, i18n);

  return (
    <SmartIntroductionView
      headline={headline}
      defaultHeadline={defaultHeadline}
      description={description}
      defaultDescription={defaultDescription}
      i18n={i18n}
      id={id}
    />
  );
};

SmartIntroductionConnector.propTypes = {
  id: PropTypes.string.isRequired,
};
